/*
 * Atlas & Grey – Sticky Add to Cart
 * ---------------------------------------------------------------------------
 * Spiegelt den echten CTA-Button aus <atlasgrey-flexible-buybox> (Text, Preis,
 * Streichpreis, Zustand) und leitet Klicks 1:1 an ihn weiter. Dadurch laeuft
 * IMMER die Original-Logik (Menge, Rabatt, Vorbesteller, Gratis-Sling-Bag).
 *
 * Zusaetzlich: zweite Zeile mit der aktuell gewaehlten Farbe als Dropdown.
 * Ein Klick im Dropdown klickt die echte Farbkachel im Buybox-Block an – auch
 * wenn diese gerade ausserhalb des Sichtbereichs liegt.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Helpers */

  // Nimmt die erste Selector-Variante, die tatsaechlich Treffer liefert.
  // Macht den Block unabhaengig davon, welche Klassennamen dein JS rendert.
  function pickAll(root, selectors) {
    if (!root) return [];
    for (var i = 0; i < selectors.length; i++) {
      var found = root.querySelectorAll(selectors[i]);
      if (found.length) return Array.prototype.slice.call(found);
    }
    return [];
  }

  function firstText() {
    for (var i = 0; i < arguments.length; i++) {
      var v = arguments[i];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
    return '';
  }

  function isOn(el, classNames, attrPairs) {
    if (!el) return false;
    for (var i = 0; i < classNames.length; i++) {
      if (el.classList.contains(classNames[i])) return true;
    }
    for (var j = 0; j < attrPairs.length; j++) {
      if (el.getAttribute(attrPairs[j][0]) === attrPairs[j][1]) return true;
    }
    return false;
  }

  function money(el) {
    return el && !el.hidden ? (el.textContent || '').trim() : '';
  }

  /* -------------------------------------------------------------- Component */

  class AtlasgreyStickyAtc extends HTMLElement {
    connectedCallback() {
      // position:fixed bricht in Ancestors mit transform/filter/contain.
      // Deshalb haengen wir uns einmalig direkt an <body>.
      if (!this.hasAttribute('data-relocated')) {
        // Im Theme-Editor kann der Block neu gerendert werden: alte, bereits
        // an <body> verschobene Instanz mit gleicher ID vorher entfernen.
        var previous = this.id ? document.getElementById(this.id) : null;
        if (previous && previous !== this) previous.remove();
        this.setAttribute('data-relocated', '');
        document.body.appendChild(this);
        return; // connectedCallback feuert danach erneut
      }
      if (this.__booted) return;
      this.__booted = true;

      this.settings = {
        anchor: this.dataset.anchor || 'cta',              // 'cta' | 'block'
        offset: parseInt(this.dataset.triggerOffset, 10) || 0,
        colorPrefix: this.dataset.colorPrefix || '',
        colorEmpty: this.dataset.colorEmptyText || '',
        reserveSpace: this.dataset.reserveSpace === 'true',
        showColorRow: this.dataset.showColorRow !== 'false',
        showError: this.dataset.showError === 'true',
        setPrefix: this.dataset.setPrefix || 'Set'
      };

      this.buybox = this.resolveBuybox();
      if (!this.buybox) {
        this.remove();
        return;
      }

      this.src = {
        button:   this.buybox.querySelector('[data-add-to-cart]'),
        label:    this.buybox.querySelector('[data-button-label]'),
        subtext:  this.buybox.querySelector('[data-button-subtext]'),
        price:    this.buybox.querySelector('[data-button-price]'),
        compare:  this.buybox.querySelector('[data-button-compare]'),
        error:    this.buybox.querySelector('[data-error]'),
        options:  this.buybox.querySelector('.agbb__options') || this.buybox
      };
      if (!this.src.button) {
        this.remove();
        return;
      }

      this.ui = {
        bar:        this.querySelector('[data-sticky-bar]'),
        button:     this.querySelector('[data-sticky-cta]'),
        label:      this.querySelector('[data-sticky-label]'),
        subtext:    this.querySelector('[data-sticky-subtext]'),
        separator:  this.querySelector('[data-sticky-separator]'),
        price:      this.querySelector('[data-sticky-price]'),
        compare:    this.querySelector('[data-sticky-compare]'),
        colorRow:   this.querySelector('[data-sticky-color-row]'),
        colorTrig:  this.querySelector('[data-sticky-color-trigger]'),
        colorValue: this.querySelector('[data-sticky-color-value]'),
        colorSwatch:this.querySelector('[data-sticky-color-swatch]'),
        panel:      this.querySelector('[data-sticky-panel]'),
        panelList:  this.querySelector('[data-sticky-panel-list]'),
        backdrop:   this.querySelector('[data-sticky-backdrop]'),
        error:      this.querySelector('[data-sticky-error]')
      };

      this.bindEvents();
      this.observeSource();
      this.observeVisibility();
      this.syncAll();
    }

    disconnectedCallback() {
      if (this.__mo) this.__mo.disconnect();
      if (this.__io) this.__io.disconnect();
      document.removeEventListener('click', this.__onDocClick, true);
      document.removeEventListener('keydown', this.__onKeydown);
      window.removeEventListener('resize', this.__onResize);
    }

    /* --------------------------------------------------------- Quellsuche */

    resolveBuybox() {
      var wanted = this.dataset.buyboxSelector;
      if (wanted) {
        var explicit = document.querySelector(wanted);
        if (explicit) return explicit;
      }
      // Erster Buybox-Block auf der Seite, der einen CTA besitzt
      var all = document.querySelectorAll('atlasgrey-flexible-buybox');
      for (var i = 0; i < all.length; i++) {
        if (all[i].querySelector('[data-add-to-cart]')) return all[i];
      }
      return null;
    }

    /* ------------------------------------------------------------ Events */

    bindEvents() {
      var self = this;

      // Klick auf Sticky-CTA => echter Button wird geklickt (Original-Logik)
      this.ui.button.addEventListener('click', function (event) {
        event.preventDefault();
        if (self.src.button.disabled) return;
        self.src.button.click();
        // Zustaende wie "Wird hinzugefuegt ..." kommen ueber den MutationObserver
        requestAnimationFrame(function () { self.syncButton(); });
      });

      this.ui.colorTrig.addEventListener('click', function (event) {
        event.preventDefault();
        self.togglePanel();
      });

      this.ui.backdrop.addEventListener('click', function () { self.closePanel(); });

      this.__onKeydown = function (event) {
        if (event.key === 'Escape' && self.classList.contains('is-open')) {
          self.closePanel();
          self.ui.colorTrig.focus();
        }
      };
      document.addEventListener('keydown', this.__onKeydown);

      this.__onDocClick = function (event) {
        if (!self.classList.contains('is-open')) return;
        if (self.ui.panel.contains(event.target) || self.ui.colorTrig.contains(event.target)) return;
        self.closePanel();
      };
      document.addEventListener('click', this.__onDocClick, true);

      this.__onResize = function () { self.updateReservedSpace(); };
      window.addEventListener('resize', this.__onResize);
    }

    /* ------------------------------------------- Quelle beobachten (Sync) */

    observeSource() {
      var self = this;
      this.__mo = new MutationObserver(function () {
        // gebuendelt in einen Frame, damit schnelle DOM-Updates nicht flackern
        if (self.__raf) return;
        self.__raf = requestAnimationFrame(function () {
          self.__raf = null;
          self.syncAll();
        });
      });

      var config = {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'disabled', 'class', 'aria-checked', 'aria-disabled', 'data-selected', 'src']
      };

      this.__mo.observe(this.src.button, config);
      this.__mo.observe(this.src.options, config);
      if (this.src.error) this.__mo.observe(this.src.error, config);
    }

    /* --------------------------------------------------- Sichtbarkeit */

    observeVisibility() {
      var self = this;
      var anchor = this.settings.anchor === 'block' ? this.buybox : this.src.button;

      if (!('IntersectionObserver' in window)) {
        var onScroll = function () {
          var rect = anchor.getBoundingClientRect();
          self.setVisible(rect.bottom + self.settings.offset < 0);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return;
      }

      this.__io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Sichtbar nur, wenn der Anker komplett NACH OBEN aus dem Bild ist,
          // d.h. der Nutzer scrollt unterhalb des Haupt-CTA.
          var scrolledPast = !entry.isIntersecting &&
                             entry.boundingClientRect.bottom + self.settings.offset < 0;
          self.setVisible(scrolledPast);
        });
      }, { threshold: 0 });

      this.__io.observe(anchor);
    }

    setVisible(visible) {
      if (this.__visible === visible) return;
      this.__visible = visible;
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (!visible) this.closePanel();
      this.updateReservedSpace();
    }

    updateReservedSpace() {
      if (!this.settings.reserveSpace) return;
      var height = this.__visible ? this.ui.bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--agsticky-height', height + 'px');
      document.body.classList.toggle('agsticky-has-bar', !!this.__visible);
    }

    /* ---------------------------------------------------------- Syncing */

    syncAll() {
      this.syncButton();
      this.syncColors();
      this.syncError();
      this.updateReservedSpace();
    }

    syncButton() {
      var src = this.src;
      var ui = this.ui;

      ui.label.textContent = src.label ? (src.label.textContent || '').trim() : '';

      if (src.subtext) {
        var subtext = (src.subtext.textContent || '').trim();
        var showSub = !!subtext && !src.subtext.hidden;
        ui.subtext.textContent = subtext;
        ui.subtext.hidden = !showSub;
      } else {
        ui.subtext.hidden = true;
      }

      var priceText = money(src.price);
      var compareText = money(src.compare);

      ui.price.textContent = priceText;
      ui.price.hidden = !priceText;
      ui.compare.textContent = compareText;
      ui.compare.hidden = !compareText;
      ui.separator.hidden = !priceText;

      var disabled = !!src.button.disabled || src.button.getAttribute('aria-disabled') === 'true';
      ui.button.disabled = disabled;
      ui.button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      ui.button.classList.toggle('is-disabled', disabled);
    }

    syncError() {
      if (!this.settings.showError || !this.src.error) return;
      var text = (this.src.error.textContent || '').trim();
      this.ui.error.textContent = text;
      this.ui.error.hidden = !text;
    }

    /* --------------------------------------------------- Farb-Erkennung */

    // Aktive Angebotskarte (Einzelset / Duo / Familien-Set / Vorbestellung)
    activeOffer() {
      return this.src.options.querySelector('[data-offer].is-active') ||
             this.src.options.querySelector('[data-offer][aria-checked="true"]');
    }

    // Liefert Gruppen: [{ label: 'Set 1', tiles: [{el,name,image,selected,disabled}] }]
    readColorGroups() {
      var offer = this.activeOffer();
      if (!offer) return [];

      var selector = offer.querySelector('[data-selector]');
      if (!selector) return [];

      var rows = pickAll(selector, [
        '[data-row]',
        '.agbb__row',
        '.agbb__selector-row',
        '.agbb__set-row'
      ]);
      var containers = rows.length ? rows : [selector];
      var self = this;

      return containers.map(function (row, index) {
        var tiles = pickAll(row, [
          '[data-tile]',
          '[data-variant-id]',
          '.agbb__tile',
          '[role="radio"]',
          'button'
        ]).map(function (el, tileIndex) {
          return self.readTile(el, tileIndex);
        }).filter(function (tile) { return !!tile; });

        return { label: self.readRowLabel(row, index, containers.length), tiles: tiles };
      }).filter(function (group) { return group.tiles.length > 0; });
    }

    readRowLabel(row, index, total) {
      var explicit = firstText(
        row.getAttribute && row.getAttribute('data-row-label'),
        (row.querySelector('.agbb__row-title, .agbb__selector-title, [data-row-title]') || {}).textContent
      );
      if (explicit) return explicit;
      if (total <= 1) return '';
      var number = firstText((row.querySelector('.agbb__row-number, [data-row-number]') || {}).textContent);
      return number ? number.replace(/[.:]\s*$/, '') : this.settings.setPrefix + ' ' + (index + 1);
    }

    readTile(el, index) {
      // Reine Layout-Wrapper aussortieren
      if (el.hasAttribute('data-add-to-cart')) return null;

      var img = el.querySelector('img');
      var name = firstText(
        el.getAttribute('data-color-name'),
        el.getAttribute('data-name'),
        el.getAttribute('data-color'),
        el.getAttribute('data-variant-title'),
        (el.querySelector('.agbb__tile-name, [data-tile-name]') || {}).textContent,
        el.getAttribute('aria-label'),
        el.getAttribute('title'),
        img && img.getAttribute('alt'),
        'Farbe ' + (index + 1)
      );

      return {
        el: el,
        name: name,
        image: img ? img.currentSrc || img.src : '',
        selected: isOn(el, ['is-active', 'is-selected'], [
          ['aria-checked', 'true'],
          ['data-selected', 'true'],
          ['aria-pressed', 'true']
        ]),
        disabled: !!el.disabled || isOn(el, ['is-soldout', 'is-sold-out', 'is-unavailable'], [
          ['aria-disabled', 'true'],
          ['data-available', 'false']
        ])
      };
    }

    syncColors() {
      if (!this.settings.showColorRow) {
        this.ui.colorRow.hidden = true;
        return;
      }

      var groups = this.readColorGroups();
      this.__groups = groups;

      if (!groups.length) {
        this.ui.colorRow.hidden = true;
        this.closePanel();
        return;
      }
      this.ui.colorRow.hidden = false;

      // ---- Zeile 2: aktuelle Auswahl anzeigen
      var parts = [];
      var firstSelected = null;
      groups.forEach(function (group) {
        var selected = group.tiles.filter(function (t) { return t.selected; })[0];
        if (!selected) return;
        if (!firstSelected) firstSelected = selected;
        parts.push(group.label ? group.label + ': ' + selected.name : selected.name);
      });

      this.ui.colorValue.textContent = parts.length
        ? this.settings.colorPrefix + (this.settings.colorPrefix ? ' ' : '') + parts.join(' · ')
        : this.settings.colorEmpty;

      var swatchEnabled = this.ui.colorSwatch &&
                          this.ui.colorSwatch.classList.contains('agsticky__color-swatch');
      if (swatchEnabled && firstSelected && firstSelected.image) {
        this.ui.colorSwatch.style.backgroundImage = 'url("' + firstSelected.image + '")';
        this.ui.colorSwatch.hidden = false;
      } else if (this.ui.colorSwatch) {
        this.ui.colorSwatch.hidden = true;
      }

      // ---- Dropdown-Inhalt neu aufbauen
      this.renderPanel(groups);
    }

    renderPanel(groups) {
      var self = this;
      var list = this.ui.panelList;
      list.innerHTML = '';

      groups.forEach(function (group, groupIndex) {
        if (group.label) {
          var heading = document.createElement('div');
          heading.className = 'agsticky__panel-heading';
          heading.textContent = group.label;
          list.appendChild(heading);
        }

        var groupEl = document.createElement('div');
        groupEl.className = 'agsticky__panel-group';
        groupEl.setAttribute('role', 'radiogroup');
        groupEl.setAttribute('aria-label', group.label || 'Farbe');

        group.tiles.forEach(function (tile) {
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'agsticky__panel-item';
          item.setAttribute('role', 'radio');
          item.setAttribute('aria-checked', tile.selected ? 'true' : 'false');
          if (tile.selected) item.classList.add('is-active');
          if (tile.disabled) {
            item.classList.add('is-disabled');
            item.disabled = true;
          }

          var thumb = document.createElement('span');
          thumb.className = 'agsticky__panel-thumb';
          if (tile.image) thumb.style.backgroundImage = 'url("' + tile.image + '")';
          item.appendChild(thumb);

          var name = document.createElement('span');
          name.className = 'agsticky__panel-name';
          name.textContent = tile.name;
          item.appendChild(name);

          var check = document.createElement('span');
          check.className = 'agsticky__panel-check';
          check.setAttribute('aria-hidden', 'true');
          check.innerHTML = '<svg viewBox="0 0 20 20" width="14" height="14" fill="none">' +
            '<path d="M4 10.5l4 4 8-9" stroke="currentColor" stroke-width="2.2" ' +
            'stroke-linecap="round" stroke-linejoin="round"/></svg>';
          item.appendChild(check);

          item.addEventListener('click', function (event) {
            event.preventDefault();
            if (tile.disabled) return;
            // Echte Kachel im Buybox-Block klicken => Original-Logik laeuft
            tile.el.click();
            requestAnimationFrame(function () {
              self.syncAll();
              self.closePanel();
              self.ui.colorTrig.focus();
            });
          });

          groupEl.appendChild(item);
        });

        list.appendChild(groupEl);
        if (groupIndex < groups.length - 1) {
          var divider = document.createElement('div');
          divider.className = 'agsticky__panel-divider';
          list.appendChild(divider);
        }
      });
    }

    /* --------------------------------------------------------- Dropdown */

    togglePanel() {
      if (this.classList.contains('is-open')) this.closePanel();
      else this.openPanel();
    }

    openPanel() {
      if (!this.__groups || !this.__groups.length) return;
      this.classList.add('is-open');
      this.ui.colorTrig.setAttribute('aria-expanded', 'true');
      this.ui.panel.hidden = false;
      var active = this.ui.panelList.querySelector('.agsticky__panel-item.is-active') ||
                   this.ui.panelList.querySelector('.agsticky__panel-item');
      if (active) active.focus({ preventScroll: true });
    }

    closePanel() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.ui.colorTrig.setAttribute('aria-expanded', 'false');
      this.ui.panel.hidden = true;
    }
  }

  if (!customElements.get('atlasgrey-sticky-atc')) {
    customElements.define('atlasgrey-sticky-atc', AtlasgreyStickyAtc);
  }
})();
